// extracted by mini-css-extract-plugin
export default {"modal":"Modal_modal__yEgVW","wrapper":"Modal_wrapper__BE2UA","form":"Modal_form__Kth9F","ani":"Modal_ani__1ZvXe","cross":"Modal_cross__-Alxa"};